/*URL para el back*/
export const BACKEND_BASE_URL = 'https://curso-de-movilidad.auteco.com.co/back/wp-json/auteco_e-learning/';

export const HOME = "/";
export const CURSO = "/curso";
export const EXAMEN = "/examen/:id";
